import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toString1pkumu07cwy4m as toString,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_getInstance29ub64y89bvyi as Companion_getInstance } from '../ExecutionContext.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HttpMethod_Get_instance;
var HttpMethod_Post_instance;
var HttpMethod_entriesInitialized;
function HttpMethod_initEntries() {
  if (HttpMethod_entriesInitialized)
    return Unit_instance;
  HttpMethod_entriesInitialized = true;
  HttpMethod_Get_instance = new (HttpMethod())('Get', 0);
  HttpMethod_Post_instance = new (HttpMethod())('Post', 1);
}
var HttpMethodClass;
function HttpMethod() {
  if (HttpMethodClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'HttpMethod');
    HttpMethodClass = $;
  }
  return HttpMethodClass;
}
var HttpHeaderClass;
function HttpHeader() {
  if (HttpHeaderClass === VOID) {
    class $ {
      constructor(name, value) {
        this.f49_1 = name;
        this.g49_1 = value;
      }
      toString() {
        return 'HttpHeader(name=' + this.f49_1 + ', value=' + this.g49_1 + ')';
      }
      hashCode() {
        var result = getStringHashCode(this.f49_1);
        result = imul(result, 31) + getStringHashCode(this.g49_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof HttpHeader()))
          return false;
        var tmp0_other_with_cast = other instanceof HttpHeader() ? other : THROW_CCE();
        if (!(this.f49_1 === tmp0_other_with_cast.f49_1))
          return false;
        if (!(this.g49_1 === tmp0_other_with_cast.g49_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'HttpHeader');
    HttpHeaderClass = $;
  }
  return HttpHeaderClass;
}
function _get_hasBody__xziwnf($this) {
  return !($this.i49_1 == null) || !($this.j49_1 == null);
}
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(statusCode) {
        this.h49_1 = statusCode;
        this.i49_1 = null;
        this.j49_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.k49_1 = ArrayList().u2();
      }
      l49(bodySource) {
        // Inline function 'kotlin.apply' call
        // Inline function 'kotlin.check' call
        if (!!_get_hasBody__xziwnf(this)) {
          var message = 'body() can only be called once';
          throw IllegalStateException().o(toString(message));
        }
        this.i49_1 = bodySource;
        return this;
      }
      v48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.k49_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.n2(element);
        return this;
      }
      x48(headers) {
        // Inline function 'kotlin.apply' call
        this.k49_1.z2(headers);
        return this;
      }
      n37() {
        return new (HttpResponse())(this.h49_1, this.k49_1, this.i49_1, this.j49_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var HttpResponseClass;
function HttpResponse() {
  if (HttpResponseClass === VOID) {
    class $ {
      constructor(statusCode, headers, bodySource, bodyString) {
        this.m49_1 = statusCode;
        this.n49_1 = headers;
        this.o49_1 = bodySource;
        this.p49_1 = bodyString;
      }
      q49() {
        var tmp0_elvis_lhs = this.o49_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          var tmp1_safe_receiver = this.p49_1;
          var tmp_0;
          if (tmp1_safe_receiver == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            tmp_0 = (new (Buffer())()).y3y(tmp1_safe_receiver);
          }
          tmp = tmp_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'HttpResponse');
    HttpResponseClass = $;
  }
  return HttpResponseClass;
}
var BuilderClass_0;
function Builder_0() {
  if (BuilderClass_0 === VOID) {
    class $ {
      constructor(method, url) {
        this.q48_1 = method;
        this.r48_1 = url;
        this.s48_1 = null;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.t48_1 = ArrayList().u2();
        this.u48_1 = Companion_getInstance().r42_1;
      }
      w48(body) {
        // Inline function 'kotlin.apply' call
        this.s48_1 = body;
        return this;
      }
      v48(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp0 = this.t48_1;
        // Inline function 'kotlin.collections.plusAssign' call
        var element = new (HttpHeader())(name, value);
        tmp0.n2(element);
        return this;
      }
      x48(headers) {
        // Inline function 'kotlin.apply' call
        this.t48_1.z2(headers);
        return this;
      }
      e44(executionContext) {
        // Inline function 'kotlin.apply' call
        this.u48_1 = this.u48_1.f44(executionContext);
        return this;
      }
      n37() {
        return new (HttpRequest())(this.q48_1, this.r48_1, this.t48_1, this.s48_1, this.u48_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass_0 = $;
  }
  return BuilderClass_0;
}
var HttpRequestClass;
function HttpRequest() {
  if (HttpRequestClass === VOID) {
    class $ {
      constructor(method, url, headers, body, executionContext) {
        this.r49_1 = method;
        this.s49_1 = url;
        this.t49_1 = headers;
        this.u49_1 = body;
        this.v49_1 = executionContext;
      }
      w49(method, url) {
        // Inline function 'kotlin.apply' call
        var this_0 = new (Builder_0())(method, url);
        if (!(this.u49_1 == null)) {
          this_0.w48(this.u49_1);
        }
        this_0.x48(this.t49_1);
        this_0.e44(this.v49_1);
        return this_0;
      }
      x49(method, url, $super) {
        method = method === VOID ? this.r49_1 : method;
        url = url === VOID ? this.s49_1 : url;
        return $super === VOID ? this.w49(method, url) : $super.w49.call(this, method, url);
      }
    }
    initMetadataForClass($, 'HttpRequest');
    HttpRequestClass = $;
  }
  return HttpRequestClass;
}
function HttpMethod_Get_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Get_instance;
}
function HttpMethod_Post_getInstance() {
  HttpMethod_initEntries();
  return HttpMethod_Post_instance;
}
//region block: exports
export {
  HttpHeader as HttpHeader1d7ldebjomr00,
  Builder_0 as Builder2ocxamygt14i4,
  Builder as Builder1mo34du82b3c6,
  HttpMethod_Get_getInstance as HttpMethod_Get_getInstance1iq7uubvx4wdk,
  HttpMethod_Post_getInstance as HttpMethod_Post_getInstancedk9zwal3qkxy,
};
//endregion

//# sourceMappingURL=Http.mjs.map
